import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth';

import PaymentLinkOutcomePage from './PaymentLinkOutcomePage';

const PaymentLinkOutcomeRoute: FuseRouteItemType[] = [];

PaymentLinkOutcomeRoute.push({
  path: 'payment-link-outcome',
  element: <PaymentLinkOutcomePage />,
  auth: AUTH_ROLES.onlyGuest,
});

export default PaymentLinkOutcomeRoute;

// http://localhost:3000/payment-link-outcome?id=160aa6f1-8465-4254-a5b2-3d06821895c1&single_payment=true
